/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var UsageBlue = function UsageBlue(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Usage icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['icon--usage-blue--linear-gradient', 'icon--usage-blue--linear-gradient-2', 'icon--usage-blue--linear-gradient-3', 'icon--usage-blue--linear-gradient-4', 'icon--usage-blue--linear-gradient-5', 'icon--usage-blue--linear-gradient-6', 'icon--usage-blue--linear-gradient-7', 'icon--usage-blue--linear-gradient-8', 'icon--usage-blue--linear-gradient-9', 'icon--usage-blue--linear-gradient-10', 'icon--usage-blue--linear-gradient-11', 'icon--usage-blue--linear-gradient-12', 'icon--usage-blue--linear-gradient-13', 'icon--usage-blue--linear-gradient-14', 'icon--usage-blue--linear-gradient-15', 'usage--blue--clip0', 'usage--blue--filter0_f', 'usage--blue--filter1_f', 'usage--blue--filter2_f', 'usage--blue--filter3_f'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    viewBox: "0 0 140 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(gradientIds['usage--blue--clip0'], ")")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h140v200H0z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".36",
    d: "M66.322 193.854L.176 155.688 0 38.455 66.146.29l65.678 38.166.176 117.233-65.678 38.166z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".13",
    d: "M132 155.688l-65.678 38.166-66.03-38.166 65.62-38.107L132 155.688z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-1'], ")")
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(gradientIds['usage--blue--filter0_f'], ")")
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.975 141.4l10.295.749v5.124L77.976 141.4z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-2'], ")"),
    fillOpacity: "0.06"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(gradientIds['usage--blue--filter1_f'], ")")
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.208 148.55l10.295.749v5.124l-10.295-5.873z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-3'], ")"),
    fillOpacity: "0.06"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(gradientIds['usage--blue--filter2_f'], ")")
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.212 156.975l10.294.749v5.124l-10.294-5.873z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-4'], ")"),
    fillOpacity: "0.06"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(gradientIds['usage--blue--filter3_f'], ")")
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2 164.886l10.295.75v5.124L32.2 164.886z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-5'], ")"),
    fillOpacity: "0.06"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: ".52",
    d: "M132 155.688l-.059 6.205L66.322 200v-6.146L132 155.688z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-6'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".42",
    d: "M66.322 193.854V200L.234 161.893l.059-6.205 66.029 38.166z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-7'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.332 92.224l4.195 2.422v59.906l-4.195-2.422V92.224z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-8'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.53 94.646l4.2-2.425v59.91l-4.2 2.425v-59.91z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-9'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "M69.332 92.22l4.198-2.423 4.198 2.424-4.198 2.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.49 106.725l4.195 2.422v53.905l-4.195-2.421v-53.906z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-11'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.688 109.147l4.2-2.425v53.91l-4.2 2.424v-53.909z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-11'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "M53.49 106.725l4.198-2.424 4.197 2.424-4.197 2.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.164 80.343l4.195 2.421v64.563l-4.195-2.422V80.343z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-12'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.362 82.76l4.2-2.427v64.573l-4.2 2.425V82.76z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-13'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "M84.162 80.343l4.197-2.424 4.198 2.424-4.198 2.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.322 124.074l4.195 2.422v44.345l-4.195-2.422v-44.345z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-14'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.52 126.5l4.2-2.425v44.345l-4.2 2.425V126.5z",
    fill: "url(#".concat(gradientIds['icon--usage-blue--linear-gradient-15'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5FF",
    d: "M38.322 124.075l4.198-2.424 4.197 2.424-4.197 2.424z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient'],
    x1: "65.989",
    y1: "33.537",
    x2: "65.989",
    y2: "255.378",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F2FF",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".466",
    stopColor: "#BDCCFE",
    stopOpacity: ".467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".814",
    stopColor: "#99B4FE",
    stopOpacity: ".815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".999",
    stopColor: "#8BABFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8CACFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-1'],
    x1: "122.119",
    y1: "172.702",
    x2: "26.622",
    y2: "109.529",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#D5D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#D6D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".999",
    stopColor: "#91BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#97AEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-2'],
    x1: "92.016",
    y1: "145.12",
    x2: "19.807",
    y2: "115.713",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B44D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#1B44D6",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-3'],
    x1: "77.249",
    y1: "152.27",
    x2: "5.039",
    y2: "122.863",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B44D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#1B44D6",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-4'],
    x1: "61.252",
    y1: "160.695",
    x2: "-10.957",
    y2: "131.288",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B44D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#1B44D6",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-5'],
    x1: "46.241",
    y1: "168.607",
    x2: "-25.969",
    y2: "139.199",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B44D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#1B44D6",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-6'],
    x1: "66.302",
    y1: "177.858",
    x2: "132.007",
    y2: "177.858",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#DDDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-7'],
    x1: ".234",
    y1: "177.859",
    x2: "66.304",
    y2: "177.859",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D96FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#97C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-8'],
    x1: "71.43",
    y1: "93.435",
    x2: "45.49",
    y2: "138.364",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#C5D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#D2DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-9'],
    x1: "73.356",
    y1: "88.128",
    x2: "53.793",
    y2: "152.119",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#E4E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-10'],
    x1: "55.588",
    y1: "107.936",
    x2: "32.246",
    y2: "148.365",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#C5D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#D2DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-11'],
    x1: "57.514",
    y1: "102.875",
    x2: "44.055",
    y2: "163.279",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#E4E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-12'],
    x1: "86.262",
    y1: "81.554",
    x2: "58.305",
    y2: "129.976",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#C5D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#D2DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-13'],
    x1: "88.189",
    y1: "60.435",
    x2: "48.566",
    y2: "129.057",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#E4E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-14'],
    x1: "40.419",
    y1: "125.285",
    x2: "21.217",
    y2: "158.544",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#C5D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#D2DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['icon--usage-blue--linear-gradient-15'],
    x1: "42.345",
    y1: "124.783",
    x2: "40.629",
    y2: "173.274",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#E4E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: gradientIds['usage--blue--filter0_f'],
    x: "74.975",
    y: "138.4",
    width: "16.295",
    height: "11.873",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "1.5",
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: gradientIds['usage--blue--filter1_f'],
    x: "60.208",
    y: "145.55",
    width: "16.295",
    height: "11.873",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "1.5",
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: gradientIds['usage--blue--filter2_f'],
    x: "44.212",
    y: "153.975",
    width: "16.295",
    height: "11.873",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "1.5",
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: gradientIds['usage--blue--filter3_f'],
    x: "29.2",
    y: "161.886",
    width: "16.295",
    height: "11.873",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "1.5",
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: gradientIds['usage--blue--clip0']
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h140v200H0z"
  }))));
};
UsageBlue.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var UsageBlue$1 = UsageBlue;

export { UsageBlue$1 as default };
